<template>
  <div class="expertDetails">
    <base-header v-if="showType" activeIndex="4" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/market/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/market/wap/banner.png" />

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title">全球资讯 尽在此刻</h1>
        <h1 class="titles">全球资讯</h1>
        <h1 class="titles">尽在此刻</h1>
        <p class="banner-content-intro">国际级的视野 · 专家级的行情解读</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="Details">
      <h2>{{ data.title }}</h2>
      <div class="timeSource">
        <label>{{ data.NewsTime }}</label>
        <p>
          <span>来源：</span>
          <span>{{data.source}}</span>
        </p>
      </div>
      <hr>
      <div class="zhaiyao">
        摘要：{{data.synopsis}}
      </div>
      <div class="NewsContext" v-html="data.content"></div>
      <p class="WriterName">编辑/{{ data.writerName }}</p>
    </div>
    <base-footer v-if="showType" />
  </div>
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import { pmCmsSystemRelayUrlParam } from '@/apis/transfer'
export default {
  name:'expertDetails',
  components: {
    BaseHeader,
    BaseFooter,

  },
  data(){
    return{
      // 父级页面传来的参数
      query:{
        id:'',
      },
      // 获取到的数据
      data:{

      },
      showType:true
    }
  },
  created(){
    if (this.$route.query.from) {
      this.showType = false

    };
    // 传参控制显示顶部和底部
    this.$emit('controlShow', false);
    // 获取参数
    this.query.id = this.$route.query.id;
    // 初始化数据
    this.init(this.query);
  },
  methods:{
    init(attr){
      pmCmsSystemRelayUrlParam('hotNewaDetailApi', attr).then(res => {
        this.data = res;

      }).catch(err => {
        console.log(err);
      })

    }
  }
}
</script>

<style lang="less">
.expertDetails{
  width: 100%;
  .bigImg{
    width: 100%;
    height: 600px;
    background: url('../../../static/market/banner.png') no-repeat;
    background-size: cover;
  }
     .banner__layer {
       position: relative;
  
       .banner-img {
         display: block;
         width: 100%;
       }
  
       .banner-imgs {
         display: none;
         width: 100%;
       }
  
       .banner-content {
         position: absolute;
         top: 50%;
         left: 30%;
         transform: translate(-50%, -50%);
         z-index: 11;
         color: #FFFFFF;
  
         .title {
           display: block;
         }
  
         .titles {
           display: none;
         }
  
         h1 {
           font-size: 68px;
           margin: 0;
         }
  
         &-intro {
           font-size: 18px;
         }
  
         &-download {
           display: flex;
           align-items: center;
           margin-top: 50px;
  
           &-btn {
             width: 198px;
             line-height: 56px;
             color: #FFFFFF;
             background: #FA2314;
             border-radius: 4px;
             margin-right: 10px;
             cursor: pointer;
             text-align: center;
             font-size: 20px;
             font-weight: 700;
             display: inline-block;
           }
  
           &-text {
             display: flex;
             align-items: center;
  
             >div {
               display: flex;
               align-items: center;
               color: #FFFFFF;
               padding: 4px 40px;
  
               &:first-child {
                 border-right: 1px solid #0F0F11;
               }
  
               img {
                 width: 38px;
                 height: 38px;
                 margin-right: 12px;
               }
             }
           }
         }
       }
     }
  .Details{
    width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 50px 0 70px;
    .timeSource{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      label{
        color: rgb(129, 129, 128);
        line-height: 21px;
      }
      p{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
        line-height: 21px;
        span:nth-child(1){
          color: rgb(129, 129, 128);
        }
      }
    }
    hr{
      width: 100%;
      margin: 0 auto;
    }
    .zhaiyao{
      background-color: #f3f5fb;
      box-sizing: border-box;
      padding: 40px;
      margin: 20px 0;
    }
    .WriterName{
      width: 100%;
      margin-top: 30px;
    }
    // .NewsContext{
    //   p{
    //     img{
    //       text-align: center !important;
    //     }
    //   }
    // }
  }
}
@media screen and (max-width: 500px) {
  .expertDetails{
    width: 100%;
    .bigImg {
      width: 100%;
      height: 450px;
      background: url('../../../static/index/wapImg/maketBanner.jpg') no-repeat;
      background-size: cover;
    }
         .banner__layer {
    
           .banner-img {
             display: none;
           }
    
           .banner-imgs {
             display: block;
             height: 500px;
    
           }
    
           .banner-content {
             position: absolute;
             top: 37%;
             left: 50%;
             transform: translate(-50%, -50%);
             z-index: 11;
             padding-top: 40px;
            //  background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
             // color: #000;
             color: #FFFFFF;
    
             .title {
               display: none;
             }
    
             .titles {
               color: #FFFFFF;
               display: block;
               white-space: nowrap;
             }
    
             h1 {
               font-size: 58px;
               line-height: 77px;
               margin: 0;
               width: 100%;
               text-align: center;
               white-space: wrap;
             }
    
             &-intro {
               font-size: 14px;
               text-align: center;
             }
    
             &-download {
               display: flex;
               flex-direction: column;
               align-items: center;
               margin-top: 20px;
    
               &-btn {
                 width: 180px;
                 line-height: 34px;
                 color: #FFFFFF;
                 background: #FA2314;
                 border-radius: 4px;
                 margin-right: 10px;
                 cursor: pointer;
                 text-align: center;
                 font-size: 14px;
                 font-weight: 700;
                 margin-bottom: 20px;
               }
    
               &-text {
                 display: flex;
                 align-items: center;
    
                 >div {
                   display: flex;
                   align-items: center;
                   color: #0F0F11;
                   color: #FFFFFF;
    
                   padding: 2px 20px;
                   font-size: 10px;
    
                   &:first-child {
                     border-right: 1px solid #fff;
                   }
    
                   img {
                     width: 24px;
                     height: 24px;
                     margin-right: 12px;
                   }
                 }
               }
             }
           }
                 .banner-co {
                   top: 33%;
                 }
        
                 }
        
                 .bannerss {
                   padding-top: 0;
                 }
    .Details{
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 20px 0 30px;
      h2{
        font-size: 18px;
        text-align: center;
      }
      .timeSource{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        label{
          color: rgb(129, 129, 128);
          line-height: 21px;
          font-size: 12px;
        }
        p{
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 20px;
          line-height: 21px;
          font-size: 12px;
          span:nth-child(1){
            color: rgb(129, 129, 128);
          }
        }
      }
      hr{
        width: 95%;
        margin: 0 auto;
      }
      .zhaiyao{
        width: 95%;
        background-color: #f3f5fb;
        box-sizing: border-box;
        padding: 20px;
        margin: 20px auto;
        font-size: 14px;
      }
      .NewsContext{
        width: 95%;
        margin: 0 auto;
        p{
          font-size: 14px;
          img{
            width: 100% !important;
          }
        }
      }
      .WriterName{
        width: 95%;
        margin: 20px auto 0;
        font-size: 14px;
      }
    }
  }    
}
</style>